var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { padding, margin } from 'styled-system';
import * as Icons from '../icons';
export var Icon;
(function (Icon) {
    Icon["delete"] = "DeleteIcon";
    Icon["back"] = "BackIcon";
    Icon["cross"] = "CrossIcon";
    Icon["plus"] = "PlusIcon";
    Icon["share"] = "ShareIcon";
    Icon["download"] = "DownloadIcon";
    Icon["chevron"] = "ChevronIcon";
    Icon["chevronLeft"] = "ChevronIcon";
    Icon["chevronRight"] = "ChevronIcon";
    Icon["chevronUp"] = "ChevronIcon";
    Icon["chevronDown"] = "ChevronIcon";
    Icon["home"] = "HomeIcon";
    Icon["pencil"] = "PencilIcon";
    Icon["times"] = "TimesIcon";
    Icon["location"] = "LocationIcon";
    Icon["camera"] = "CameraIcon";
    Icon["circletick"] = "CircleWithTick";
    Icon["email"] = "EmailIcon";
    Icon["eye"] = "EyeIcon";
    Icon["eyeinvisible"] = "EyeInvisibleIcon";
    Icon["info"] = "InfoIcon";
    Icon["loading"] = "LoadingIcon";
    Icon["phone"] = "PhoneIcon";
    Icon["tick"] = "TickIcon";
})(Icon || (Icon = {}));
var withMargin = function (Component) { return styled(Component)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 8px;\n  ", "\n  ", "\n"], ["\n  margin-right: 8px;\n  ", "\n  ", "\n"])), margin, padding); };
export var StyledIcon = withMargin(function (_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return React.cloneElement(children, __assign({ className: className }, props));
});
// Styled icon has a default right margin of 8px. 
//It can be overriden by using StyledIcon tag as <StyledIcon mr="Our Value in px">
//inplace of mr attribute, margin attribute can also be used (in shorthand form).
function getIcon(_a) {
    var icon = _a.icon, title = _a.title, small = _a.small;
    if (React.isValidElement(icon))
        return icon;
    var props = {};
    var IconNode = Icons[Icon[icon]];
    switch (icon) {
        case 'chevronRight':
            props.type = 'right';
            break;
        case 'chevronUp':
            props.type = 'up';
            break;
        case 'chevronDown':
            props.type = 'down';
            break;
    }
    if (IconNode)
        return React.createElement(IconNode, __assign({ height: title ? '1em' : 18 }, props));
    return null;
}
;
export default getIcon;
var templateObject_1;
